import { InputHTMLAttributes } from 'react';

import { ErrorMessage } from '@lib/forms/ErrorMessage';

import { FormInputPrimitive, IFormInputPrimitiveProps } from './FormInputPrimitive';

export interface IFormInputProps extends IFormInputPrimitiveProps {
  onChange: (value: string) => void;
  disabled?: boolean;
  value: string;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label: string;
  fullWidth?: boolean;
  errors?: ErrorMessage[];
}

export const FormInput = ({
  className,
  onChange,
  errors = [],
  value,
  disabled,
  labelClassName,
  inputProps,
  fullWidth = false,
  ...rest
}: IFormInputProps) => {
  const relatedError = errors.find(e => e.inputIds?.includes(rest.id));
  return (
    <FormInputPrimitive
      labelClassName={`font-semibold mb-2 ${labelClassName ?? ''}`}
      ErrorSlot={() =>
        relatedError ? (
          <div className="text-error-shade mt-2 text-xs font-semibold">
            {relatedError.errorMessage}
          </div>
        ) : (
          <></>
        )
      }
      className={className}
      {...rest}
    >
      <input
        id={rest.id}
        placeholder={inputProps?.placeholder ?? rest.label}
        onChange={e => {
          onChange(e.currentTarget.value);
        }}
        disabled={disabled}
        value={value}
        className={`focus:border-primary mt-2 flex flex-col rounded-sm border-2 p-2 ${
          relatedError ? 'border-error-shade' : 'border-twilight'
        } ${fullWidth ? 'w-full' : ''} ${className}`}
        {...inputProps}
      />
    </FormInputPrimitive>
  );
};
